import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';

import { VETS } from '../../constants/constants';

export default class OurVets extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 0
    };
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange = (event, value) => {
    this.setState({ value });
  };

  render() {
    const thisVet = VETS[this.state.value];

    const aboutThisVet = thisVet.about.map((aboutVet, index) => {
      return (
        <li key={`aboutvet-${this.state.value}-${index}`}>
          <i className='glyphicon glyphicon-ok' />
          &nbsp;
          {aboutVet}
        </li>
      );
    });

    const thisVetInfo = (
      <Fragment>
        <div className='vet-info'>
          <div className='title'>
            <h3>Meet {thisVet.fullName}</h3>
            <h4>{thisVet.position}</h4>
          </div>

          <hr />
          {thisVet.description !== '' && <p>{thisVet.description}</p>}
          <ul className='aboutVet-list space-small-top'>{aboutThisVet}</ul>

          {/* <div className="text-center">
            <Link to="/about" className="btn btn-vetchat2 vet-read-more">
              Read more about {thisVet.fullName}
            </Link>
          </div> */}
        </div>
      </Fragment>
    );

    const vetTabs = VETS.map((vet, index) => {
      let elementClass = 'vet-selector-item';
      if (this.state.value === index) {
        elementClass += ' active';
      }
      return (
        <li
          key={`vet-${index}`}
          onClick={() => {
            this.setState({ value: index });
          }}
          className={elementClass}
        >
          <Fragment>
            <img src={`/images/our-vets/${vet.image}`} alt={vet.vet} />
            <span className='vet-name' style={{ fontWeight: 700 }}>
              {vet.vet}
            </span>
          </Fragment>
        </li>
      );
    });
    return (
      <div className='container'>
        <div className='row'>
          <div className='col-sm-12 vets-header text-center'>
            <h2 className='section-title'>Meet our Vets</h2>
            <p className='text-center' style={{ marginBottom: 20 }}>
              Our awesome Vets are Australian board certified with a minimum of
              5 years experience, and are passionate about improving pet health
              incomes with easy access to the right advice.
            </p>
          </div>
          <div className='col-sm-4 col-xs-12 vet-tab-header'>
            <ul>
              {vetTabs}
              <li className='vet-selector-item text-center'>
                <Link
                  to='/about'
                  className='btn btn-vetchat2'
                  style={{ marginTop: 25 }}
                >
                  Read more about all our Vets
                </Link>
              </li>
            </ul>
          </div>
          <div className='col-sm-8 col-xs-12 vets-tabs-content'>
            {thisVetInfo}
          </div>
        </div>
      </div>
    );
  }
}
